import { render, staticRenderFns } from "./Marketmanagelog.vue?vue&type=template&id=6e27e3b5&scoped=true&"
import script from "./Marketmanagelog.vue?vue&type=script&lang=js&"
export * from "./Marketmanagelog.vue?vue&type=script&lang=js&"
import style0 from "./Marketmanagelog.vue?vue&type=style&index=0&id=6e27e3b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27e3b5",
  null
  
)

export default component.exports